import { Node, mergeAttributes } from '@tiptap/core';
export const Channel = Node.create({
    name: 'channel',
    group: 'block',
    draggable: true,
    atom: true,
    addAttributes() {
        return {
            channels: {
                default: [],
                renderHTML(attrs) {
                    return { 'data-channels': attrs.channels.join(',') };
                },
                parseHTML(element) {
                    const channels = element.getAttribute('data-channels');
                    return channels?.split(',') ?? [];
                },
            },
        };
    },
    addCommands() {
        return {
            setChannel: () => ({ commands }) => {
                return commands.insertContent({ type: this.name });
            },
        };
    },
    parseHTML() {
        return [
            {
                tag: 'mb-channel',
            },
        ];
    },
    renderHTML({ HTMLAttributes }) {
        return ['mb-channel', mergeAttributes(HTMLAttributes)];
    },
});
//# sourceMappingURL=channel.js.map